"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2242],{

/***/ 97643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var ProfilePicture = function ProfilePicture(_ref) {
  var _name$match$join$subs, _name$match;

  var user = _ref.user,
      size = _ref.size,
      fontSize = _ref.fontSize;
  var gravatar = user.gravatar,
      pii = user.pii,
      profile_picture = user.profile_picture;
  var name = user.name;

  if (!name) {
    name = pii.name;
  }

  var height, width;
  fontSize = fontSize ? "text-".concat(fontSize) : "text-lg";

  switch (size.toString()) {
    case "8":
      height = "28px";
      width = "28px";
      break;

    case "10":
      height = "35px";
      width = "35px";
      break;

    case "12":
      height = "48px";
      width = "48px";
      break;

    case "14":
      height = "56px";
      width = "56px";
      break;

    case "16":
    default:
      height = "64px";
      width = "64px";
      break;
  }

  return gravatar || profile_picture ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
    className: " flex-shrink-0 rounded-full group-hover:opacity-75 font-bold flex items-center justify-center",
    src: profile_picture !== null && profile_picture !== void 0 ? profile_picture : gravatar,
    alt: "".concat(name, "'s Profile Picture"),
    width: width,
    height: height
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: " flex-shrink-0 rounded-full group-hover:opacity-75 font-bold flex items-center justify-center text-white ".concat(fontSize, " ").concat((0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .getStaticColor */ .bo)(name)),
    style: {
      height: height,
      width: width
    },
    children: (_name$match$join$subs = (_name$match = name.match(/\b\w/g)) === null || _name$match === void 0 ? void 0 : _name$match.join("").substring(0, 2)) !== null && _name$match$join$subs !== void 0 ? _name$match$join$subs : "?"
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(ProfilePicture));

/***/ }),

/***/ 72242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72510);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11355);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86215);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59417);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10288);
/* harmony import */ var _components_candidates_ProfilePicture__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97643);
/* harmony import */ var _components_commonlayout_AccountMenuLogo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28150);
/* harmony import */ var _components_commonlayout_CreditsRemaining__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32122);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _services_modules_organization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54912);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);
















var AccountMenu = function AccountMenu(_ref) {
  var _user$organization;

  var size = _ref.size,
      user = _ref.user,
      logout = _ref.logout,
      module = _ref.module,
      check = _ref.check,
      _ref$onboarding = _ref.onboarding,
      onboarding = _ref$onboarding === void 0 ? false : _ref$onboarding,
      isEngineer = _ref.isEngineer,
      userRoles = _ref.userRoles;

  var _userRole = (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .userRole */ .xZ)(user),
      userIsCompany = _userRole.userIsCompany;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();

  var _useGetOrganizationDa = (0,_services_modules_organization__WEBPACK_IMPORTED_MODULE_9__/* .useGetOrganizationDataQuery */ .lW)({
    id: user === null || user === void 0 ? void 0 : (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.id
  }, {
    skip: !user
  }),
      data = _useGetOrganizationDa.data;

  var organization = data === null || data === void 0 ? void 0 : data.organization;
  var showTeamAndNotifications = userRoles && (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .userHasClientRole */ .qt)(userRoles);
  var showButtons = !(0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .isPublicPage */ .wl)(router) ? Boolean(userIsCompany && organization) : true;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [size === "large" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: user ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "hidden lg:ml-4 lg:flex lg:items-center",
        children: [userIsCompany && organization && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_commonlayout_CreditsRemaining__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          user: user
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu */ .v, {
          as: "div",
          className: "ml-4 relative flex-shrink-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Button */ .v.Button, {
              className: "bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-200",
              "data-test-id": "navbar-account-dropdown-button",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "sr-only",
                children: "Open user menu"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_commonlayout_AccountMenuLogo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                user: user,
                organization: organization
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_12__/* .Transition */ .u, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "transition ease-out duration-100",
            enterFrom: "transform opacity-0 scale-95",
            enterTo: "transform opacity-100 scale-100",
            leave: "transition ease-in duration-75",
            leaveFrom: "transform opacity-100 scale-100",
            leaveTo: "transform opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Items */ .v.Items, {
              className: "origin-top-right absolute right-0 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10 w-max",
              children: [!onboarding && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/".concat(module, "/account"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      "data-test-id": "account-page",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "px-4 py-2 text-sm text-gray-700 flex hover:bg-gray-100",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_candidates_ProfilePicture__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                          user: user,
                          size: 12
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "px-4 flex flex-col justify-center",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                            className: "text-sm font-bold flex",
                            children: [user === null || user === void 0 ? void 0 : user.name, module === "company" && (organization === null || organization === void 0 ? void 0 : organization.name) !== undefined ? " (".concat(organization === null || organization === void 0 ? void 0 : organization.name, ")") : ""]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                            className: "flex items-center",
                            children: [user === null || user === void 0 ? void 0 : user.email, user !== null && user !== void 0 && user.email_verified_at ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                              icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faCircleCheck */ .fV7,
                              className: "flex-shrink-0 h-5 w-5 text-teal-500 pl-1",
                              "aria-hidden": "true",
                              title: "Verified"
                            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                              icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faCircleExclamation */ .xHz,
                              className: "flex-shrink-0 h-5 w-5 text-red-500 pl-1",
                              "aria-hidden": "true",
                              title: "Action Needed"
                            })]
                          })]
                        })]
                      })
                    })
                  })
                })
              }, "account"), !check && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/".concat(module, "/").concat(module === "company" ? "dashboard" : "profile"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        className: "block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100",
                        children: module === "company" ? "Dashboard" : "Profile"
                      })
                    })
                  })
                })
              }, module === "company" ? "dashboard" : "profile"), module === "company" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                      href: "/".concat(module, "/company"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                          className: "block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100",
                          children: "Company"
                        })
                      })
                    })
                  })
                }, "company"), showTeamAndNotifications && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/".concat(module, "/team"),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100",
                            children: "Team"
                          })
                        })
                      })
                    })
                  }, "team"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/".concat(module, "/notifications"),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100",
                            children: "Notifications"
                          })
                        })
                      })
                    })
                  }, "notifications")]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                children: function children(_ref2) {
                  var active = _ref2.active;
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                    className: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .classNames */ .AK)(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700 w-full text-left"),
                    onClick: function onClick() {
                      return logout({
                        message: "logout"
                      });
                    },
                    "data-test-id": "logout",
                    children: "Logout"
                  });
                }
              }, "logout")]
            })
          })]
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "flex items-center gap-x-5 md:gap-x-8",
        children: showButtons && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "hidden lg:inline-block lg:ml-6 lg:space-x-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/login",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
              className: "font-medium text-primary-600 hover:text-primary-500",
              type: "button",
              "data-test-id": "login",
              children: "Log in"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: "hidden lg:inline-block lg:ml-6 lg:space-x-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
              href: "/signup",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                className: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-primary-600 text-white hover:text-slate-100 hover:bg-primary-500 active:bg-primary-800 active:text-primary-100 focus-visible:outline-primary-600",
                type: "button",
                "data-test-id": "sign-up",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                  children: "Sign Up"
                })
              })
            }), !isEngineer && !["/404", "/about", "/demo", "/engineers", "/share/[shareCode]", "/privacy-policy", "/cookie-policy", "/terms-and-conditions"].includes(router === null || router === void 0 ? void 0 : router.pathname) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
              href: "/demo",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                target: "_blank",
                className: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-red-400 text-white hover:text-slate-100 hover:bg-primary-500 active:bg-red-600 active:text-red-100 focus-visible:outline-red-400",
                type: "button",
                "data-test-id": "book-a-demo",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                  children: "Book a Demo"
                })
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "-mr-1 md:hidden",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                className: "relative z-10 flex h-8 w-8 items-center justify-center [&:not(:focus-visible)]:focus:outline-none",
                "aria-label": "Toggle Navigation",
                id: "headlessui-popover-button-:R1p6:",
                type: "button",
                "aria-expanded": "false",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("svg", {
                  "aria-hidden": "true",
                  className: "h-3.5 w-3.5 overflow-visible stroke-slate-700",
                  fill: "none",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                    d: "M0 1H14M0 7H14M0 13H14",
                    className: "origin-center transition"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                    d: "M2 2L12 12M12 2L2 12",
                    className: "origin-center transition scale-90 opacity-0"
                  })]
                })
              })
            })
          })]
        })
      })
    }), size === "small" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: !user ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "bg-white",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          href: "/login",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: "block w-full px-5 py-3 text-center font-medium text-primary-600 bg-gray-50 hover:bg-gray-100",
            "data-test-id": "login",
            children: "Log in"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          href: "/signup",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: "block w-full px-5 py-3 mb-2 text-center font-medium rounded-full bg-primary-600 text-white hover:text-slate-100 hover:bg-primary-500 active:bg-primary-800 active:text-primary-100",
            type: "button",
            "data-test-id": "sign-up",
            children: "Sign up"
          })
        }), !isEngineer && !["/404", "/about", "/demo", "/engineers", "/share/[shareCode]", "/privacy-policy", "/cookie-policy", "/terms-and-conditions"].includes(router === null || router === void 0 ? void 0 : router.pathname) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          href: "/demo",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            target: "_blank",
            className: "block w-full px-5 py-3 mb-2 text-center font-medium rounded-full bg-red-400 text-white hover:text-slate-100 hover:bg-primary-500 active:bg-red-600 active:text-red-100",
            type: "button",
            "data-test-id": "book-a-demo",
            children: "Book a demo"
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Popover.Panel */ .J.Panel, {
        focus: true,
        className: "z-30 absolute top-0 right-0 max-w-none w-full p-2 transition transform origin-top",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "pt-3 pb-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "flex items-center justify-between px-5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_commonlayout_AccountMenuLogo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                user: user,
                organization: organization
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "-mr-2",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Popover.Button */ .J.Button, {
                  className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                    className: "sr-only",
                    children: "Close menu"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faXmark */ .g82,
                    className: "h-5 w-5",
                    "aria-hidden": "true"
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: "pt-4 pb-2",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "flex items-center px-5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_candidates_ProfilePicture__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                user: user,
                size: 12
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: "ml-3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "text-base font-medium text-gray-800",
                  children: user === null || user === void 0 ? void 0 : user.name
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "text-sm font-medium text-gray-500",
                  children: user === null || user === void 0 ? void 0 : user.email
                })]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "mt-3 px-2 space-y-1",
              children: [_constants__WEBPACK_IMPORTED_MODULE_4__/* .homeNavigation.map */ .H4.map(function (item) {
                if (item.children) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                      href: item.href,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                        "data-test-id": "".concat(item - name, "-page"),
                        children: item.name
                      })
                    }, item.name), item.children.map(function (child) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: child.href,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                          className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                          "data-test-id": "".concat(child - name, "-page"),
                          children: child.name
                        })
                      }, child.name);
                    })]
                  });
                } else return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                  href: item.href,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                    "data-test-id": "".concat(item - name, "-page"),
                    children: item.name
                  })
                }, item.name);
              }), !check && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/".concat(module, "/").concat(module === "company" ? "dashboard" : "profile"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                  className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                  children: module === "company" ? "Dashboard" : "Profile"
                })
              }, module === "company" ? "dashboard" : "profile"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/".concat(module, "/account"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                  className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                  "data-test-id": "account-page",
                  children: "Account"
                })
              }, "account"), module === "company" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                  href: "/".concat(module, "/company"),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                    "data-test-id": "company-page",
                    children: "Company"
                  })
                }, "company"), showTeamAndNotifications && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/".concat(module, "/team"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                      "data-test-id": "team-page",
                      children: "Team"
                    })
                  }, "team"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/".concat(module, "/notifications"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                      "data-test-id": "notifications-page",
                      children: "Notifications"
                    })
                  }, "notifications")]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800 w-full text-left",
                onClick: logout,
                children: "Logout"
              }, "logout")]
            })]
          })]
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AccountMenu);

/***/ }),

/***/ 28150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);
/* harmony import */ var _components_candidates_ProfilePicture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97643);
/* harmony import */ var _services_modules_organization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54912);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var AccountMenuLogo = function AccountMenuLogo(_ref) {
  var _user$organization, _organization, _organization$name$ma, _organization2, _organization2$name$m;

  var user = _ref.user;

  var _userRole = (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .userRole */ .xZ)(user),
      userIsCompany = _userRole.userIsCompany;

  var _useGetOrganizationDa = (0,_services_modules_organization__WEBPACK_IMPORTED_MODULE_2__/* .useGetOrganizationDataQuery */ .lW)({
    id: user === null || user === void 0 ? void 0 : (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.id
  }, {
    skip: !user
  }),
      data = _useGetOrganizationDa.data;

  var organization = data === null || data === void 0 ? void 0 : data.organization;

  if (!organization) {
    organization = user.organization;
  }

  return userIsCompany && organization ? organization.logo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: "flex-shrink-0",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "h-12 w-12 rounded-full bg-center bg-contain bg-no-repeat border border-primary-50",
      style: {
        backgroundImage: "url(".concat(organization.logo, ")")
      },
      title: organization.name
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: "flex-shrink-0 h-12 w-12 rounded-full group-hover:opacity-75 font-bold flex items-center justify-center text-white ".concat(organization.name ? (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .getStaticColor */ .bo)((_organization = organization) === null || _organization === void 0 ? void 0 : _organization.name) : null),
    children: (_organization$name$ma = (_organization2 = organization) === null || _organization2 === void 0 ? void 0 : (_organization2$name$m = _organization2.name.match(/\b\w/g)) === null || _organization2$name$m === void 0 ? void 0 : _organization2$name$m.join("")) !== null && _organization$name$ma !== void 0 ? _organization$name$ma : "?"
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_candidates_ProfilePicture__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    user: user,
    size: 12
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AccountMenuLogo);

/***/ }),

/***/ 32122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10288);
/* harmony import */ var _services_modules_organization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54912);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var CreditsRemaining = function CreditsRemaining(_ref) {
  var _user$organization;

  var user = _ref.user;

  var _useGetOrganizationDa = (0,_services_modules_organization__WEBPACK_IMPORTED_MODULE_2__/* .useGetOrganizationDataQuery */ .lW)({
    id: user === null || user === void 0 ? void 0 : (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.id
  }, {
    skip: !user
  }),
      data = _useGetOrganizationDa.data;

  var credits_remaining = 0;

  if (data && data !== null && data !== void 0 && data.organization) {
    var _data$organization;

    credits_remaining = data === null || data === void 0 ? void 0 : (_data$organization = data.organization) === null || _data$organization === void 0 ? void 0 : _data$organization.credits_remaining;
  }

  var bgColor = "bg-primary-50",
      textColor = "text-primary-800",
      text = "Credits";

  if (credits_remaining <= _constants__WEBPACK_IMPORTED_MODULE_1__/* .candidateUnlockThreshold.min */ .ln.min) {
    bgColor = "bg-red-100";
    textColor = "text-red-800";
  } else if (credits_remaining < _constants__WEBPACK_IMPORTED_MODULE_1__/* .candidateUnlockThreshold.max */ .ln.max) {
    bgColor = "bg-yellow-100";
    textColor = "text-yellow-800";
  }

  if (credits_remaining === 1) {
    text = "Credit";
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
    className: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .classNames */ .AK)("hidden lg:inline-flex items-center rounded-full px-3 py-0.5 text-sm font-bold", bgColor, textColor),
    children: ["".concat(credits_remaining, " ").concat(text), " Remaining"]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CreditsRemaining);

/***/ }),

/***/ 54912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jl": function() { return /* binding */ useGetPublicOrganizationQuery; },
/* harmony export */   "Pu": function() { return /* binding */ useGetAllSkillsQuery; },
/* harmony export */   "WX": function() { return /* binding */ useGetAllCountriesQuery; },
/* harmony export */   "eU": function() { return /* binding */ useGetProfileDataQuery; },
/* harmony export */   "i": function() { return /* binding */ useGetClientNotificationTypesQuery; },
/* harmony export */   "kD": function() { return /* binding */ useUpdateUserMutation; },
/* harmony export */   "lW": function() { return /* binding */ useGetOrganizationDataQuery; }
/* harmony export */ });
/* unused harmony exports organizationApi, useGetCurrentUserQuery */
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15338);
/* harmony import */ var _gql_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69980);


var organizationApi = _services_api__WEBPACK_IMPORTED_MODULE_0__/* .api.injectEndpoints */ .h.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getOrganizationData: build.query({
        query: function query(variables) {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_ORGANIZATION */ .e_,
            variables: variables
          };
        }
      }),
      getAllCountries: build.query({
        query: function query() {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_ALL_COUNTRIES */ .$_
          };
        }
      }),
      getClientNotificationTypes: build.query({
        query: function query() {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_CLIENT_NOTIFICATION_TYPES */ .bp
          };
        }
      }),
      getAllSkills: build.query({
        query: function query(variables) {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_ALL_SKILLS */ .dv,
            variables: variables
          };
        }
      }),
      getPublicOrganization: build.query({
        query: function query(variables) {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_PUBLIC_ORGANIZATION */ .Jm,
            variables: variables
          };
        }
      }),
      getProfileData: build.query({
        query: function query() {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_PROFILE_DATA */ ._v
          };
        }
      }),
      getCurrentUser: build.query({
        query: function query() {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .GET_CURRENT_USER */ .PB
          };
        },
        providesTags: ["getCurrentUser"]
      }),
      updateUser: build.mutation({
        query: function query(variables) {
          return {
            document: _gql_constants__WEBPACK_IMPORTED_MODULE_1__/* .UPDATE_USER */ .AX,
            variables: variables
          };
        },
        invalidatesTags: ["getCurrentUser"]
      })
    };
  }
});
var useGetOrganizationDataQuery = organizationApi.useGetOrganizationDataQuery,
    useGetAllCountriesQuery = organizationApi.useGetAllCountriesQuery,
    useGetAllSkillsQuery = organizationApi.useGetAllSkillsQuery,
    useGetProfileDataQuery = organizationApi.useGetProfileDataQuery,
    useGetPublicOrganizationQuery = organizationApi.useGetPublicOrganizationQuery,
    useGetClientNotificationTypesQuery = organizationApi.useGetClientNotificationTypesQuery,
    useUpdateUserMutation = organizationApi.useUpdateUserMutation,
    useGetCurrentUserQuery = organizationApi.useGetCurrentUserQuery;


/***/ })

}]);